<app-dialog [dialogWithInput]="dialog">
    <app-error-card message="Aucun micro détecté" *ngIf="noAccessToMicro"></app-error-card>
    <div class="row">
        <app-form-field [sizeXl]="12" [sizeLg]="12" [size]="12" label="Micro actif">
            {{activeMicrophoneName}}
        </app-form-field>
    </div>
    <ng-container *ngIf="!noAccessToMicro && mediaStream">
        <div style="text-align: center" class="m-t-16">
            <div style="cursor: pointer;" *ngIf="!recording">
                <i-tabler
                        name="microphone"
                        class="icon-48"
                        matTooltip="Tester le micro" (click)="startRecording()"></i-tabler>
                <div>Tester le micro</div>
            </div>
            <div style="cursor: pointer;" *ngIf="recording">
                <i-tabler
                        name="player-stop-filled"
                        class="icon-48"
                        matTooltip="Tester le micro" (click)="stopRecording()"></i-tabler>
            </div>
        </div>
        <audio controls #audioPlayer style="display: none;"></audio>
    </ng-container>
</app-dialog>
